export default __webpack_public_path__ + "static/media/Acm img.88244e1e.png";